import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { TooltipDirectiveModule } from "@obg/mat.ui.common/tooltip";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CommonValidationRendererModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { OpenIdConnectTelemetryEffect } from "./sdk/open-id-connect-telemetry.effect";
import { OpenIdConnectConfigService } from "./sdk/open-id-connect.config";
import { OpenIdConnectEffect } from "./sdk/open-id-connect.effect";
import { openIdConnectReducer } from "./sdk/open-id-connect.reducer";
import { CprNumberFieldComponent } from "./src/cpr-number/cpr-number-field.component";
import { NoWhitespaceInputDirective } from "./src/no-whitespace-input/no-whitespace-input.directive";
import { OpenIdConnectCacheService } from "./src/open-id-connect-cache.service";
import { OpenIdConnectContainer } from "./src/open-id-connect.container";

const DIRECTIVES: any[] = [OpenIdConnectContainer, CprNumberFieldComponent, NoWhitespaceInputDirective];

const MAT_MODULES: any[] = [
	MatCoreModule,
	MatIconModule,
	MatMenuModule,
	MatProgressSpinnerModule,
	MatFormFieldModule,
	MatInputModule,
];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		DialogLayoutModule,
		ReactiveFormsModule,
		CommonValidationRendererModule,
		TooltipDirectiveModule,
		MAT_MODULES,
		EffectsModule.forFeature([OpenIdConnectTelemetryEffect, OpenIdConnectEffect]),
		StoreModule.forFeature("openIdConnect", openIdConnectReducer),
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	providers: [OpenIdConnectCacheService, OpenIdConnectConfigService],
})
export class OpenIdConnectModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, OpenIdConnectContainer);
	}
}
